<template>
  <a
    @click="isScrollToTop ? scrollTop() : emitCreateItinerary()"
    v-show="isScrollToTop ? visible : this.someActivitiesAreSelected"
    class="bottom-right fade-in-image"
  >
    <slot></slot>
  </a>
</template>

<script>
import store from "../../store";

export default {
  data() {
    return {
      visible: false,
    };
  },
  props: {
    isScrollToTop: Boolean,
  },
  methods: {
    scrollTop: function () {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId);
        }
        window.scroll(0, window.pageYOffset - 50);
      }, 0);
    },
    scrollListener: function (e) {
      this.visible = window.scrollY > 150;
    },
    emitCreateItinerary: function () {
      this.$emit("create-itinerary");
    },
  },
  mounted: function () {
    if (this.isScrollToTop) {
      window.addEventListener("scroll", this.scrollListener);
    }
  },
  beforeDestroy: function () {
    if (this.isScrollToTop) {
      window.removeEventListener("scroll", this.scrollListener);
    }
  },
  computed: {
    someActivitiesAreSelected() {
      return store.getters.activitiesSelectedList.length > 0;
    },
  },
};
</script>

<style scoped>
</style>
